module.exports = __webpack_public_path__ + "static/media/ask-expert.ad57c3c7.png";